export default __webpack_public_path__ + "962e356.svg";